// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__lApGF","title":"Info_title__3IBT2","links":"Info_links__2g11N","link":"Info_link__3DRMb","logo":"Info_logo__3Ob46"};